import { render, staticRenderFns } from "./BotsTransactions.vue?vue&type=template&id=ffc902ba&scoped=true&"
import script from "./BotsTransactions.vue?vue&type=script&lang=js&"
export * from "./BotsTransactions.vue?vue&type=script&lang=js&"
import style0 from "./BotsTransactions.vue?vue&type=style&index=0&id=ffc902ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc902ba",
  null
  
)

export default component.exports